export default "__VITE_ASSET__R8NEB0Vv__"